import React from 'react';
import { Table } from '@devexpress/dx-react-grid-bootstrap4';
import { A } from 'hookrouter';

const ClickableTableCell = ({ href, showText, onClick, children }) => {
    let className = children ? 'd-flex flex-row unset-padding' : 'unset-padding';

    return (
        <Table.Cell className={className}>
            <div className='d-flex align-items-center h-100 w-100'>
                <A
                    className='btn btn-link w-100 h-100 text-left clickable-table-cell border-0 d-flex align-items-center '
                    href={href}
                    onClick={onClick}>
                    {showText}
                </A>
                {children ? children : null}
            </div>
        </Table.Cell>
    );
};

export default ClickableTableCell;
